import { documentsModuleManifest } from '../documents.module.js';
import { documentsSettingRegistrations } from '../settings/documents-setting-definitions.js';
export const documentsWebModuleContribution = {
    moduleId: 'documents',
    manifest: documentsModuleManifest,
    settingRegistrations: documentsSettingRegistrations,
    settingEditors: [],
    hostContracts: [],
    hostContributions: [],
    routes: [
        {
            id: 'documents.web.instances',
            moduleId: 'documents',
            path: '/documents',
            requiredPermission: 'documents.instances.read',
            navigation: {
                id: 'documents.navigation.instances',
                fallbackLabel: 'Documents',
                labelConfigurationKey: 'documents.copy.instances',
                labelValueProperty: 'navigationLabel',
                priority: 80,
            },
            load: () => import('./documents-instances.page.js'),
        },
        {
            id: 'documents.web.templates',
            moduleId: 'documents',
            path: '/documents/templates',
            requiredPermission: 'documents.templates.read',
            navigation: {
                id: 'documents.navigation.templates',
                fallbackLabel: 'Document templates',
                labelConfigurationKey: 'documents.copy.templates',
                labelValueProperty: 'navigationLabel',
                priority: 81,
            },
            load: () => import('./documents-templates.page.js'),
        },
        {
            id: 'documents.web.training-records',
            moduleId: 'documents',
            path: '/documents/training-records',
            requiredPermission: 'documents.training-records.read',
            navigation: {
                id: 'documents.navigation.training-records',
                fallbackLabel: 'Training records',
                labelConfigurationKey: 'documents.copy.training-records',
                labelValueProperty: 'navigationLabel',
                priority: 82,
            },
            load: () => import('./documents-training-records.page.js'),
        },
        {
            id: 'documents.web.protected-forms',
            moduleId: 'documents',
            path: '/documents/employee-forms',
            requiredPermission: 'documents.workforce-protected-forms.read-own',
            navigation: {
                id: 'documents.navigation.protected-forms',
                fallbackLabel: 'Employee forms',
                labelConfigurationKey: 'documents.copy.protected-forms',
                labelValueProperty: 'navigationLabel',
                priority: 83,
            },
            load: () => import('./documents-protected-forms.page.js'),
        },
        {
            id: 'documents.web.signed-policies',
            moduleId: 'documents',
            path: '/documents/signed-policies',
            requiredPermission: 'documents.knowledge-signed-policies.read',
            navigation: {
                id: 'documents.navigation.signed-policies',
                fallbackLabel: 'Signed policies',
                labelConfigurationKey: 'documents.copy.signed-policies',
                labelValueProperty: 'navigationLabel',
                priority: 84,
            },
            load: () => import('./documents-signed-policies.page.js'),
        },
    ],
};
export default documentsWebModuleContribution;
//# sourceMappingURL=documents-web.module-contribution.js.map